import React from 'react';
import red from '@material-ui/core/colors/red';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { ValidatorComponent } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const red300 = red['500'];

const style = {
    right: 0,
    fontSize: '12px',
    color: red300,
    position: 'absolute',
    marginTop: '-25px',
};

class RadioListValidatorElement extends ValidatorComponent {
    constructor(props) {
        super(props);

        this.State = {
            value: props.value
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value });
        }
    }

    render() {
        const { errorMessages, validators, requiredError, value, ...rest } = this.props;

        const items = this.props.options.map(option =>
            <FormControlLabel style={{marginTop: '10px'}} value={option.value} control={<Radio />} label={option.display} title={option.title} />
        );

        return (
            <React.Fragment>
                <Grid item xs={12}>
                    <Typography>{this.props.question}</Typography>
                </Grid>
                <Grid item xs={12} style={{ marginLeft: '10px' }}>

                    <RadioGroup
                        name={this.props.name}
                        value={this.props.value === undefined ? undefined : this.props.value.toString()}
                        onChange={this.props.readOnly !== null && this.props.readOnly !== undefined ? "" : this.handleChange}
                        readOnly={rest.readOnly}
                        name={rest.name}
                        children={rest.children}
                        ref={(r) => { this.input = r; }}
                    >
                        {items}
                    </RadioGroup>
                    {this.errorText()}
                </Grid>
            </React.Fragment>
        );
    }

    handleChange = (event) => {
        console.log(event);
        console.log(event.target.value);
        this.setState({ value: event.target.value }, () => {
            this.validate(this.state.value);
        });
        this.props.handleChange(event);
    }

    errorText = () => {

        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <div style={style}>
                {this.getErrorMessage()}
            </div>
        );
    }
}

export default RadioListValidatorElement;